module.exports = __webpack_public_path__ + "img/Authority2.817107ee.svg";